import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito ingredientes caros?',
    a: 'No, todo lo que necesitas está en tu supermercado habitual.'
  }, {
    q: '¿Es una dieta completa de 24 horas?',
    a: 'No, es un protocolo enfocado en tu ventana de claridad matutina.'
  }, {
    q: '¿Qué pasa si ya tomo hormonas?',
    a: 'Este método es el complemento perfecto para que tu TRH funcione con mayor eficiencia neuronal.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Recibirás un enlace de descarga inmediata en tu correo tras el pago.'
  }];
  return <section className="w-full bg-cream py-20 px-6" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-16">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-6" data-id="element-17">
            {faqs.map((faq, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-cream-dark" data-id="element-18">
                <h3 className="text-xl font-bold text-sage mb-2" data-id="element-19">{faq.q}</h3>
                <p className="text-charcoal-light m-0" data-id="element-20">{faq.a}</p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}